import React from "react";
import Styles from "./HighlyRatedGuids.module.css";
import Guides from "../../i18n/translations/GuideData/GuideDataEn";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import guideDataEN from "../../i18n/translations/GuideData/GuideDataEn";
import guideDataAr from "../../i18n/translations/GuideData//GuideDataAr";
import guideDataKu from "../../i18n/translations/GuideData/GuideDataKu";

function HighlyRatedGuids() {
	const { t, i18n } = useTranslation();

	const currentLanguage = i18n.language;
	const guideData =
		currentLanguage === "en"
			? guideDataEN
			: currentLanguage === "ar"
			? guideDataAr
			: guideDataKu;

	const sortedGuides = [...guideData].sort((a, b) => {
		if (b.rate !== a.rate) {
			return b.rate - a.rate;
		}
		return b.noOfReviews - a.noOfReviews;
	});

	const top5Guides = sortedGuides.slice(0, 5);

	return (
		<div
			className={Styles.ratedGuideContainer}
			dir='ltr'
		>
			<h1 className={Styles.h1}>{t("top5.heading")}</h1>
			<div className={Styles.containerStyle}>
				<Marquee
					speed={150}
					loop={0}
					pauseOnHover
				>
					{top5Guides.map((guide, index) => (
						<Link
							to={`guidePage/${guide.idGuide}`}
							state={{
								idGuide: guide.idGuide,
								name: guide.name,
								image: guide.image,
								imgCover: guide.imgCover,
								province: guide.province,
								rate: guide.rate,
								noOfReviews: guide.noOfReviews,
								ProgramsData: guide.ProgramsData,
								UsersReviews: guide.UsersReviews,
							}}
							className={Styles.link}
							key={index}
						>
							<div className={Styles.imageH1}>
								{console.log(guide.idGuide, "1")}
								<img
									className={Styles.imageRate}
									src={guide.image}
									alt={"Highly rated guide"}
								/>
								<h1>{guide.name}</h1>
							</div>
						</Link>
					))}
				</Marquee>
			</div>
		</div>
	);
}

export default HighlyRatedGuids;
